import {
  DEFAULT_LANGUAGE,
  Language,
  REGISTERED_LANGUAGES
} from '../constants/i18n';

export function capitalize(str: string) {
  return `${str[0].toUpperCase()}${str.slice(1)}`;
}

export function camelCaseToSnakeCase(str: string): string {
  if (!str) {
    return str;
  }
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

const isValidLanguage = (languageId: string): languageId is Language => {
  return REGISTERED_LANGUAGES.includes(languageId as Language);
};

export function formatRequestId(id: number | string): string {
  const numericId = typeof id === 'string' ? parseInt(id, 10) : id;

  if (isNaN(numericId)) {
    return '#0000';
  }

  const safeId = Math.abs(numericId);

  return `#${safeId.toString().padStart(4, '0')}`;
}

export function normalizeLanguage(language?: string) {
  let normalizedLanguage = '';

  if (typeof language === 'string') {
    normalizedLanguage = language.replace('_', '-');
  }
  if (normalizedLanguage && isValidLanguage(normalizedLanguage)) {
    return normalizedLanguage;
  }

  return DEFAULT_LANGUAGE;
}
